<script>
import api from '@utils/api'
import mixins from '../apimixins'
import Parameters from '../AvailabilityOfTransmittersInTheWorkshop/parameters'
import TablePaginator from '@components/paginator'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'

export default {
  name: 'AvailabilityOfTransmittersInTheWorkshop',
  components: {
    AdjustColumnsDialog,
    Parameters,
    TablePaginator,
  },
  mixins: [mixins],
  data() {
    return {
      modelName: 'AvailabilityOfTransmittersInTheWorkshop',
      isLoading: false,
      firstRun: true,
      showDialog: false,
      headers: [
        { text: 'plug_transmitter_id', value: 'serial', sortable: true },
        { text: 'group', value: 'goodsGroup', sortable: true, show: true },
        { text: 'workshop', value: 'organisation', sortable: true },
        { text: 'status', value: 'status', sortable: true, show: true },
        { text: 'article', value: 'articleName', sortable: true, show: true },
        { text: 'date', value: 'date', sortable: true },
        {
          text: 'first_eventsV2_id',
          value: 'initialEvent',
          sortable: true,
          show: true,
        },
        {
          text: 'first_eventsV2_date',
          value: 'initialEventDate',
          sortable: true,
          show: true,
        },
        {
          text: 'last_eventsV2_id',
          value: 'lastEvent',
          sortable: true,
          show: true,
        },
        {
          text: 'last_eventsV2_date',
          value: 'lastEventDate',
          sortable: true,
          show: true,
        },
      ],
    }
  },
  computed: {
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  methods: {
    setParams(value) {
      this.otherParams = { ...value }
      this.resetPage()
      this.init()
    },
    async init() {
      this.getPaginator()
      let filters = this.getFilters()
      if (!this.firstRun || this.filtersEmpty(filters)) {
        this.getDataSet()
        this.firstRun = false
      }
    },
    getDataSet() {
      this.isLoading = true
      this.prepareFilterParams()
      this.getDevicesInTheWorkshop()
    },

    getDevicesInTheWorkshop() {
      this.otherParams.start_date = this.params.start_date
      this.otherParams.end_date = this.params.end_date
      return api
        .getReportData('plug_transmitter_assignments', this.params)
        .then(response => {
          this.setResponseParams(response)
          this.content = response.content
          this.isLoading = false
        })
    },
    getState(type) {
      switch (type) {
        case 2:
          return 'label__shipped'
        case 1:
        case 4:
        case 8:
          return 'label__on_warehouse'
        default:
          break
      }
    },
    headerToWrap(header) {
      return (
        header.includes('first_eventsV2') ||
        header.includes('plug_transmitter_id')
      )
    },
    getHeaderAlign(header) {
      if (this.headerToWrap(header.text)) {
        let styleResult = {
          'max-width': '1px',
          'white-space': 'pre-line',
          display: 'inline-block',
        }
        if (
          header.text.includes('eventsV2') ||
          header.text.includes('plug_transmitter_id')
        ) {
          styleResult = { ...styleResult, 'min-width': '95px' }
        }
        return styleResult
      }
      return {}
    },
    getIconCentered(header) {
      return this.headerToWrap(header.text) ? { 'vertical-align': 'super' } : {}
    },
    justifyPadding(header) {
      return this.headerToWrap(header.text)
        ? {
            'text-align': 'left',
            'padding-left': '8px !important',
            'padding-right': '12px !important',
          }
        : {
            'text-align': 'left',
            'padding-left': '8px',
            'padding-right': '8px',
          }
    },
  },
}
</script>

<template>
  <div>
    <parameters
      @set-params="setParams($event)"
    />
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            <span> {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              small>expand_less
            </v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <router-link
              v-if= "userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.serial,
                                                   goodsGroup: props.item.goodsGroup }} "> {{ props.item.serial }}
            </router-link>
            <span v-else>{{ props.item.serial }}</span>
          </td>
          <td v-if="!hideValues('goodsGroup')">{{ props.item.goodsGroup ? $t(`goodsgroup.${props.item.goodsGroup}.name`) : '-' }}</td>
          <td>
            <router-link
              v-if="userAllowedToNavigate && props.item.organisation"
              :to="{ name: 'organization', params: { orgId: props.item.organisation }} "> {{ getValue('organization', props.item.organisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.organisation">{{ getValue('organization', props.item.organisation) }}</span>
            <span v-if="!props.item.organisation">{{ '-' }}</span>
          </td>
          <td v-if="!hideValues('status')">{{ props.item.status ? $t(getState(props.item.status)) : '-' }}</td>
          <td>
            <router-link
              v-if="props.item.articleName && userAllowedToNavigate && !hideValues('articleName')"
              :to="{name:'goodsItem', params: {goodsId: props.item.goodsId.toString()}}">
              {{ props.item.articleName }}
            </router-link>
            <span v-else>{{ props.item.articleName }}</span>
          </td>
          <td>{{ dateFormat(props.item.date) }}</td>
          <td 
            v-if="!hideValues('initialEvent')" 
            :class="$style.wrappedRowPadding"> {{ props.item.goodsGroup === 3 ? $t('label__not_available') : props.item.initialEvent ? props.item.initialEvent : "-" }}
          </td>
          <td
            v-if="!hideValues('initialEventDate')"
            :class="$style.wrappedRowPadding"> {{ props.item.goodsGroup === 3 ? $t('label__not_available') : dateFormat(props.item.initialEventDate) }}</td>
          <td 
            v-if="!hideValues('lastEvent')"
            :class="$style.oneRowPadding"> {{ props.item.lastEvent ? props.item.lastEvent : "-" }}</td>
          <td 
            v-if="!hideValues('lastEventDate')"
            :class="$style.oneRowPadding"> {{ dateFormat(props.item.lastEventDate) }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)"/>
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  text-align: left;
  border: 1px solid #dfdfdf;

  th {
    padding-right: 8px !important;
    padding-left: 8px !important;
    outline: none;
  }
  td {
    padding-right: 8px !important;
    padding-left: 8px !important;
    white-space: nowrap;
  }
  .wrapText {
    white-space: pre-line;
  }
  .oneRowPadding {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }

  .wrappedRowPadding {
    padding-right: 12px !important;
    padding-left: 8px !important;
  }
}
</style>
